import { gql } from "apollo-angular";

export default gql`
  query Me {
    me {
      objects {
        id
        firstName
        lastName
        email
        role
        companies {
          id
        }
        status
      }
    }
  }
`;
